<!-- <p>
  home works!
</p> -->
<div *ngIf="showTutorial" class="tutorial-container">
  <div class="tutorial-box">
    <div class="row">
      <!-- Levi deo -->
      <div class="col-12 col-md-6 tutorial-column">
        <p [innerHTML]="media.KratakOpis"></p>
        <ol class="tutorial-list">
          <li *ngFor="let button of buttons; let i = index" class="tutorial-list-item">
            <p [innerHTML]="button.OpisTastera"></p>
            <button
              class="btn btn-primary tutorial-button"
              (click)="buttonClick(button.LinkTastera)"
            >
              {{ button.LabelaTastera }}
            </button>
          </li>
        </ol>
      </div>

      <!-- Desni deo -->
      <div class="col-12 col-md-6 tutorial-column">
        <div class="responsive-iframe-container">
          <iframe
            *ngIf="videoAvailable; else imageTemplate"
            class="responsive-iframe"
            [src]="safeVideoUrl"
            allowfullscreen
          ></iframe>
          <ng-template #imageTemplate>
            <img
              [src]="safeImageUrl"
              class="responsive-image"
              style="width: 100%; height: auto;"
            />
          </ng-template>
        </div>
      </div>
    </div>

    <!-- Detaljan opis ispod videa -->
    <div class="tutorial-details">
      <p [innerHTML]="media.DetaljanOpis"></p>
    </div>

    <!-- Dugme ispod detaljnog opisa -->
    <div class="tutorial-footer">
      <button
        type="button"
        class="btn btn-primary tutorial-footer-button"
        (click)="toggleTutorial()"
      >
        Nemoj više prikazivati video tutorijal
      </button>
    </div>
  </div>
</div>





<div *ngIf="!showTutorial">
<div class="row p-2 mt-5">
  <div class="col-6 offset-3 text-center">
    <!-- <h1 class="text-secondary"><span translate="APP-NAME">YtKnjigov</span></h1> -->
    <h1 class="text-secondary"><span [translate]="'APP-NAME'">YtKnjigov</span></h1>
  </div>
  <!-- <div class="col-md-8 offset-md-2">
    <div class="row">
  <div class="col-md-4">
    <div class="card border-secondary text-center">
      <div class="card-body">
        <a routerLink="/mat">
          <h2 class="card-title">Materijalno</h2>
          <p class="card-subtitle">Materijalno</p>
        </a>
      </div>
    </div>
  </div>
  <div class="col-md-4">
    <div class="card border-secondary text-center">
      <div class="card-body">
        <a routerLink="/fin">
          <h2 class="card-title">Finansije</h2>
          <p class="card-subtitle">Finansije</p>
        </a>
      </div>
    </div>
  </div>
  <div class="col-md-4">
    <div class="card border-secondary text-center">
      <div class="card-body">
        <a routerLink="/kad">
          <h2 class="card-title">Kadrovska</h2>
          <p class="card-subtitle">Kadrovska</p>
        </a>
      </div>
    </div>
  </div>
</div>
</div> -->
</div>
<div class="row" *ngIf="hasUserRights">
  <div class="col-md-8 offset-2">
    <fak-tros-chart
      [dataSource]="dataSource">
    </fak-tros-chart>
  </div>
</div>
<div class="row mt-4" *ngIf="hasUserRights">
  <div class="col-md-3 col-lg-2 offset-2">
    <yt-info-box
      [Icon]="'chart-line'"
      [Label]="('HOME.DIAGRAM.FAKTURISANO' | translate)"
      [ChartData]="dataSource.get(0)"
      [ValueColumn]="'Ukupno'"
      [NumberFormat]="'1.2-2'"
      [ValueSuffix]="'din'">
    </yt-info-box>
  </div>
  <div class="col-md-3 col-lg-2">
    <yt-info-box
      [Icon]="'chart-line'"
      [Label]="('HOME.DIAGRAM.TROSKOVI' | translate)"
      [ChartData]="dataSource.get(1)"
      [ValueColumn]="'Ukupno'"
      [NumberFormat]="'1.2-2'"
      [ValueSuffix]="'din'">
    </yt-info-box>
  </div>
  <div class="col-md-3 col-lg-2">
    <yt-info-box
      [Icon]="'chart-line'"
      [Label]="('HOME.DIAGRAM.DUGUJE' | translate)"
      [ChartData]="dataSource.get(2)"
      [ValueColumn]="'Ukupno'"
      [NumberFormat]="'1.2-2'"
      [ValueSuffix]="'din'">
    </yt-info-box>
  </div>
  <div class="col-md-3 col-lg-2">
    <yt-info-box
      [Icon]="'chart-line'"
      [Label]="('HOME.DIAGRAM.POTRAZUJE' | translate)"
      [ChartData]="dataSource.get(3)"
      [ValueColumn]="'Ukupno'"
      [NumberFormat]="'1.2-2'"
      [ValueSuffix]="'din'">
    </yt-info-box>
  </div>
</div>
<div class="row p-2 mt-5" *ngIf="rnOdobrenih+rnPoslatih+rnOdbijenih+rnNacrta+rnStorno && rnOdobrenih+rnPoslatih+rnOdbijenih+rnNacrta+rnStorno>-1" >
    <table class="custom-table">
      <tr class="gray-background">
        <td colspan="5">
          <!-- Broj poslatih računa na SEF za poslednjih mesec dana je <b>{{rnOdobrenih+rnPoslatih+rnOdbijenih+rnNacrta+rnStorno}}</b>, od toga: -->
          {{ 'HOME.DASHBOARD.SEF_LAST_MONTH_SENT_COUNT_PREFIX' | translate }} <b>{{getBrojRacuna()}}</b>{{ 'HOME.DASHBOARD.SEF_LAST_MONTH_SENT_COUNT_SUFFIX' | translate }}
        </td>
      </tr>
      <tr>
        <td>{{ 'HOME.DASHBOARD.STATUS_APPROVED' | translate }}</td>
        <td>{{ 'HOME.DASHBOARD.STATUS_SENT_NOT_ACCEPTED' | translate }}</td>
        <td>{{ 'HOME.DASHBOARD.STATUS_REJECTED' | translate }}</td>
        <td>{{ 'HOME.DASHBOARD.STATUS_DRAFTS_COUNT' | translate }}</td>
        <td>{{ 'HOME.DASHBOARD.STATUS_STORNIRANO' | translate }}</td>
      </tr>
      <tr>
        <td>{{rnOdobrenih}}</td>
        <td>{{rnPoslatih}}</td>
        <td>{{rnOdbijenih}}</td>
        <td>{{rnNacrta}}</td>
        <td>{{rnStorno}}</td>
      </tr>
    </table>
  </div>
<div class="row p-2 mt-5" *ngIf="!(rnOdobrenih+rnPoslatih+rnOdbijenih+rnNacrta+rnStorno && rnOdobrenih+rnPoslatih+rnOdbijenih+rnNacrta+rnStorno>-1)" >
  <div class="col-6 offset-3 text-center">
    <h3 class="text-secondary">
      <span>{{ 'HOME.DASHBOARD.NO_DATA_SENT_INVOICES' | translate }}</span></h3>
  </div>
</div>
<div class="row p-2 mt-5" *ngIf="hasUserSeeSetup">
  <div class="col-6 offset-3 text-center">
    <h3 class="text-secondary">
      <span>API URL: {{apiUrl}}, Baza podataka: {{database}}, Provajder za SEF: {{provajder}}, Provajder za SEO: {{provajderSEO}}, Angular verzija: {{angularVerzija}}</span></h3>
  </div>
</div>
</div>
